import {
  asBondPriceNominal,
  asAmount,
  asGSpread,
  BondPriceNominal,
  Amount,
  GSpread,
} from "@goodfill/domain-properties";
import Decimal from "decimal.js";
import { PricedBond } from "../../PricedBond";
import { BondFilter } from "./BondFilter";

const emptyData: BondFilterDataConstraints = {
  purchasePriceMin: asBondPriceNominal(new Decimal(0)),
  purchasePriceMax: asBondPriceNominal(new Decimal(0)),
  maturityMin: 0,
  maturityMax: 0,
  yieldPercentageMin: new Decimal(0),
  yieldPercentageMax: new Decimal(0),
  amountOutstandingMin: asAmount(new Decimal(0)),
  amountOutstandingMax: asAmount(new Decimal(0)),
  esgScoreMin: 0,
  esgScoreMax: 0,
  gSpreadAskMin: asGSpread(new Decimal(0)),
  gSpreadAskMax: asGSpread(new Decimal(0)),
  ratingIndexMin: 0,
  ratingIndexMax: 0,
  searchString: "",
  availableIndustries: new Set(),
};

export interface BondFilterDataConstraints {
  purchasePriceMin: BondPriceNominal;
  purchasePriceMax: BondPriceNominal;
  maturityMin: number;
  maturityMax: number;
  yieldPercentageMin: Decimal;
  yieldPercentageMax: Decimal;
  amountOutstandingMin: Amount;
  amountOutstandingMax: Amount;
  esgScoreMin: number;
  esgScoreMax: number;
  gSpreadAskMin: GSpread;
  gSpreadAskMax: GSpread;
  // intentionally: we don't have filter for G-Spread Bid
  ratingIndexMin: number;
  ratingIndexMax: number;
  searchString: string;
  availableIndustries: Set<string>;
}

export function calculateDataConstraints(
  pricedBonds: PricedBond[],
  bondFilters: BondFilter[],
): BondFilterDataConstraints {
  if (pricedBonds.length === 0) {
    return emptyData;
  }

  const defaultCriteria = bondFilters.reduce<Partial<BondFilterDataConstraints>>((accumulator, bondFilter) => {
    return {
      ...accumulator,
      ...bondFilter.getDefaultCriteriaConstraints(pricedBonds[0]),
    };
  }, {}) as BondFilterDataConstraints;

  const result = pricedBonds.reduce((criteriaPerBond, pricedBond) => {
    return bondFilters.reduce((criteriaPerBondAndCalculator, bondFilter) => {
      return bondFilter.updateConstraintByPricedBond(pricedBond, criteriaPerBondAndCalculator);
    }, criteriaPerBond);
  }, defaultCriteria);

  return bondFilters.reduce((accumulator, filter) => filter.afterCriteriaCalculation(accumulator), result);
}
